import { BoxProps } from '../Box/Box.types'
import * as React from 'react'
import { useDisclosureProps } from '../../hooks'

export type Omit<T, U> = Pick<T, Exclude<keyof T, keyof U>>

export type ReplaceProps<Inner extends React.ElementType, P> = Omit<
  React.ComponentProps<Inner>,
  P
> &
  P

export interface AsProp<As extends React.ElementType = React.ElementType> {
  as?: As
}

export interface PrefixProps<As extends React.ElementType = React.ElementType>
  extends React.HTMLAttributes<As>,
    AsProp<As> {}

export interface PrefixRefForwardingComponent<TInitial extends React.ElementType, P = unknown> {
  <As extends React.ElementType = TInitial>(
    props: React.PropsWithChildren<ReplaceProps<As, PrefixProps<As> & P>>,
    context?: unknown,
  ): React.ReactElement | null
}

export class PrefixComponent<As extends React.ElementType, P = unknown> extends React.Component<
  ReplaceProps<As, PrefixProps<As> & P>
> {}

// Need to use this instead of typeof Component to get proper type checking.
export type PrefixComponentClass<As extends React.ElementType, P = unknown> = React.ComponentClass<
  ReplaceProps<As, PrefixProps<As> & P>
>

export interface DropdownContentProps extends BoxProps {
  isShow?: boolean
  overrideWidth?: boolean
  positionDropdown?: 'left' | 'center' | 'right'
}

export interface DropdownItemProps {
  as?: React.ElementType
  isActive?: boolean
}

export type DropdownItemComponent = PrefixRefForwardingComponent<'button', DropdownItemProps>

export interface DropdownToggleProps extends Omit<unknown, 'as'> {
  as?: React.ElementType
}

export type DropdownTrigger = 'click' | 'hover'

export interface DropdownProps extends BoxProps {
  onBlur?: () => void
  onOpen?: () => void
  trigger?: DropdownTrigger
  control?: useDisclosureProps
}

export type DropdownContextValue = {
  onToggle: (nextShow: boolean, event?: React.SyntheticEvent | Event) => void
  onClose: () => void
  onBlur?: () => void
  onOpen?: () => void
  onShow?: () => void
  trigger?: DropdownTrigger
  show: boolean
}
